var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.offer)?_c(_vm.section,{tag:"component",attrs:{"options":{ editable: _vm.editable, inline:false }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }